import { faPersonSkating } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Container, Stack, Typography } from '@mui/material';

export const NoSearchFound = () => {
  return (
    <Container className="no-search-found" maxWidth="sm" sx={{ mt: '150px', mb: '60px', color: '#767676' }}>
      <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
        <FontAwesomeIcon className="fas" icon={faPersonSkating} style={{ fontSize: '60px', maxWidth: '60px' }} />
        <Box sx={{ ml: '1em' }}>
          {/* <h1>No search results</h1>
          <h2>{`We couldn't find any content that matches your search query`}</h2> */}

          <Typography variant="h5"> No Search Results Found</Typography>
        </Box>
      </Stack>
    </Container>
  );
};

export default NoSearchFound;
